





















import Vue from "vue";
import * as R from "ramda";
import ToolMixin from "@/mixins/ToolMixin";
import FullscreenBtn from "@/components/FullscreenBtn.vue";
import NotPermitted from "@/views/NotPermitted.vue";

import {
  GisWeb_gisWeb,
  Project_project,
  GisWeb_gisWeb_perspectives_edges_node
} from "@/api-types";
import GIS_WEB from "@/graphql/projects/GisWeb.gql";

export default Vue.extend({
  name: "GisWeb",
  mixins: [ToolMixin],
  components: { FullscreenBtn, NotPermitted },
  props: { project: Object as () => Project_project },
  apollo: {
    gisWeb: {
      query: GIS_WEB,
      variables() {
        return { id: this.project.gisWeb!.id };
      },
      result() {
        document.title = `Hydromapper - Web GIS vom Projekt '${
          this.project.name
        }'`;
        this.$store.commit("setToolbarTitle", `${this.project.name}: Web GIS`);
      }
    }
  },
  data: () => ({
    gisWeb: null as GisWeb_gisWeb | null
  }),
  computed: {
    perspective(): GisWeb_gisWeb_perspectives_edges_node | undefined {
      return R.compose(
        R.path(["node"]),
        R.find(
          R.pathEq(
            ["node", "routeName"],
            this.$route.params.perspectiveRouteName
          )
        )
      )(this.gisWeb!.perspectives!
        .edges as any) as GisWeb_gisWeb_perspectives_edges_node;
    }
  }
});
